/* lua.js generated code undefined */

const Event = require("cocos/framework/components/event")
DATargetCounter = xClass("DATargetCounter", Event)
let _instance = null
DATargetCounter.getInstance = function () {
    let self = this
    if (!_instance) {
        _instance = DATargetCounter.new()
    }
    return _instance
}
DATargetCounter.prototype.ctor = function () {
    let self = this
    self.reset()
}
DATargetCounter.prototype.reset = function () {
    let self = this
    // 目标数记录列表
    self._targetCountList = table()
    self._currentTargetTotalCount = 0
    self._expectCountList = table()
    self._targetCountFormatStr = ""
    self._inLevel = false
    self._moveStep = 0
    self._orderItemDefs = table()
    self._orderItemCounted = table()
    self._showDropAdjustLoggerInGameScene = false
}
// 在关卡开始后调用
DATargetCounter.prototype.startLevel = function (levelId, recoverData, isFromReplay) {
    let self = this
    self.reset()
    self._inLevel = true
    if (recoverData && recoverData.replay && recoverData.replay.dropAdjustData) {
        self._targetCountList = table()
        self._expectCountList = clone(recoverData.replay.dropAdjustData)
       //console.log("替换dropAdjustData _targetCountList", self._targetCountList)
        console.log("替换DATargetCounter _expectCountList", self._expectCountList)
        if (!isFromReplay) {
            self._moveStep = $len(self._targetCountList)
            self._calCurrentTargetCount()
        }
    } else {
        self._targetCountList = table()
        self._expectCountList = DAManager.getInstance().getExpectCountList(levelId)
        console.log("【掉落优化】 DATargetCounter _expectCountList", self._expectCountList)
        if (!isFromReplay) {
            self._moveStep = $len(self._targetCountList)
            self._calCurrentTargetCount()
        }
    }
    self._prepareOrderList()
}
// 计算当前目标累积数
DATargetCounter.prototype._calCurrentTargetCount = function () {
    let self = this
    let count = 0
    for (let i = 1, data = self._targetCountList[1]; data; i++, data = self._targetCountList[i]) {
        for (let _ in data) {
            let num = data[_]
            if ($null(num)) continue
            count = count + num
        }
    }
    self._currentTargetTotalCount = count
}
DATargetCounter.prototype.encode = function () {
    let self = this
    let data = {
        targetCountList: self._targetCountList,
        expectCountList: self._expectCountList
    }
    return data
}
// 在bonus time之前调用，表示关卡常规阶段结束（此时并不能知道是否过关，需等bonus time结束后判定过关再调用passLevel）
DATargetCounter.prototype.endLevel = function () {
    let self = this
    self._inLevel = false
}
// 在确定过关后调用
DATargetCounter.prototype.passLevel = function () {
    let self = this
    self._inLevel = false
    self.printTargetList()
    self._targetCountFormatStr = self._getFinalFormatStr()
    cc.log("Format: " + self._targetCountFormatStr)
}
// 在确定过关后调用
DATargetCounter.prototype.failLevel = function () {
    let self = this
    self.passLevel()
}
DATargetCounter.prototype._getFinalFormatStr = function (withBreak) {
    let self = this
    let str = ""
    let count = 0
    for (let i = 1, data = self._targetCountList[1]; data; i++, data = self._targetCountList[i]) {
        if (i > 1) {
            str = str + "."
        }
        for (let _ in data) {
            let num = data[_]
            if ($null(num)) continue
            count = count + num
        }
        str = str + count
        if (withBreak && i % 20 === 0) {
            str = str + "\n"
        }
    }
    return str
}
/*     @desc: 在需要计数的地方调用，以累加单步内的目标数
	--@addNum:  增加计数
    --@type:    障碍物type，例如itemType或lockType
    --@color:   <可选参数> 障碍的颜色
    --@r:       <可选参数> 障碍所在行
    --@c:       <可选参数> 障碍所在列
 */
DATargetCounter.prototype.tryAddTargetCount = function (addNum, type, color, r, c) {
    let self = this
    if (!self._inLevel || addNum <= 0) {
        return 
    }
    let countItemDefs = table()
    let itemDef = self._getItemDefInOrderList(type, color)
    if (type === -1001) {
        // boss
        itemDef = table([1, "id", "boss"])
    }
    // 部分覆盖物盖住收集物，在减层时也要统计
    if (!itemDef && (type === GameItemType.kVar_Snow || type === GameItemType.kShell || type === GameItemType.kLock || type === GameItemType.kIce || type === LockItemType.kFilbert)) {
        if (r && c && GameBoardLogic.instance) {
            // 冰层覆盖水果
            if (type === GameItemType.kIce) {
                let seaAnimalType = GameBoardLogic.instance.getSeaAnimalTypeAtRC(r, c)
                if (seaAnimalType === 65) {
                    seaAnimalType = 64
                }
                if (seaAnimalType === 67) {
                    seaAnimalType = 68
                }
                if (seaAnimalType) {
                    itemDef = self._getItemDefInOrderList(seaAnimalType, null)
                }
            } else {
                let coverItem = GameBoardLogic.instance.getGameItemAt(r, c)
                let coverType = coverItem.itemType
                if (coverType === 0) {
                    coverType = coverItem.lockType
                }
                let forceColor = null
                if (coverType >= GameItemDefMapKey.kSurpriseBox_1 && coverType <= GameItemDefMapKey.kSurpriseBox_2) {
                    // 巧克力盒子
                    coverType = GameItemDefMapKey.kSurpriseBonus
                } else if (coverType === GameItemDefMapKey.kHoneyBottle) { // 蜂蜜罐
                    coverType = GameItemDefMapKey.kHoney
                } else if (coverType === GameItemDefMapKey.kAlienA) { // 完整的橙子
                    coverType = GameItemDefMapKey.kAlienB
                    forceColor = 21
                }
                // 查看是否覆盖了收集物
                if (self._getItemDefInOrderList(coverType, forceColor || coverItem.color || coverItem.itemColorType)) {
                    itemDef = GameItemDefManager.getDef(type)
                }
                // 如果底下有蜂蜜块，并且目标收集物包含蜂蜜块，那么计数
                let boardItem = GameBoardLogic.instance.getGameBoardAt(r, c)
                if (boardItem.honeyLevel > 0) {
                    let def = self._getItemDefInOrderList(GameItemDefMapKey.kHoney, null)
                    table.insert(countItemDefs, def)
                }
            }
        }
    }
    if (itemDef) {
        table.insert(countItemDefs, itemDef)
    }
    for (let _ = 1, itemDef = countItemDefs[1]; itemDef; _++, itemDef = countItemDefs[_]) {
        if (itemDef && self._moveStep >= 0) {
            let key = tostring(itemDef.id)
            let moveStep = self._moveStep
            if (moveStep === 0) {
                moveStep = 1
                if ($len(self._targetCountList) === 0) {
                    table.insert(self._targetCountList, moveStep, table())
                }
            }
            let data = self._targetCountList[moveStep]
            if (!data[key]) {
                data[key] = 0
            }
            data[key] = data[key] + addNum
            self._currentTargetTotalCount = self._currentTargetTotalCount + addNum
            self._orderItemCounted[tostring(key)] = true
            DATargetCountGUILogger.getInstance().updateLoggerInGameScene()
        }
    }
}
// 在玩家操作一步并棋盘稳定时调用
DATargetCounter.prototype.oneStepMoved = function () {
    let self = this
    if (!self._inLevel) {
        return 
    }
    self._moveStep = self._moveStep + 1
    if (self._moveStep > $len(self._targetCountList)) {
        table.insert(self._targetCountList, self._moveStep, table())
    }
    DATargetCountGUILogger.getInstance().updateLoggerInGameScene()
    self.printTargetList()
}
// 获取当前步数的累积计数
DATargetCounter.prototype.getCurrentTargetCount = function () {
    let self = this
    return self._currentTargetTotalCount
}
// 获取当前步数的期望计数
DATargetCounter.prototype.getCurrentExpectCount = function () {
    let self = this
    let count = 0
    if (self._moveStep > 0) {
        let moveStep = Math.min(self._moveStep, $len(self._expectCountList))
        count = self._expectCountList[moveStep] || 0
    }
    return count
}
/*     @desc: 最近一次的计数统计格式化string
 */
DATargetCounter.prototype.getTargetCountFormatStr = function () {
    let self = this
    return self._targetCountFormatStr
}
DATargetCounter.prototype.printTargetList = function () {
    let self = this
    cc.log("--------------- DATargetCounter List ---------------")
    for (let i = 1, data = self._targetCountList[1]; data; i++, data = self._targetCountList[i]) {
        let str = "Step " + i + "\t\t"
        for (let itemType in data) {
            let count = data[itemType]
            if ($null(count)) continue
            str = str + itemType + ": " + count + "\t"
        }
        cc.log(str)
    }
    cc.log("--------------- DATargetCounter List ---------------")
}
DATargetCounter.prototype._prepareOrderList = function () {
    let self = this
    let orderList = GameBoardLogic.instance.theOrderList
    if (orderList) {
        let itemDefs = GameItemDefManager.defs
        for (let k in orderList) {
            let v = orderList[k]
            if ($null(v)) continue
            let itemDef = itemDefs[tostring(v.def_id)]
            if (itemDef) {
                let itemId = tostring(itemDef.id)
                self._orderItemDefs[itemId] = itemDef
                self._orderItemCounted[itemId] = false
            }
        }
    }
}
DATargetCounter.prototype._getItemDefInOrderList = function (type, color) {
    let self = this
    if (type === null) {
        return false
    }
    for (let defId in self._orderItemDefs) {
        let itemDef = self._orderItemDefs[defId]
        if ($null(itemDef)) continue
        if (type === itemDef.itemType || type === itemDef.lockType || type === itemDef.coverType || type === itemDef.id) {
            if (!$null(color) && !$null(itemDef.color) && (color !== itemDef.color && itemDef.color !== 0)) {
                if (itemDef.color == undefined || itemDef.color == 0 || color == itemDef.color) {
                    return itemDef
                } else {
                    // Do nothing.
                }
            } else {
                return itemDef
            }
        }
    }
    return null
}
DATargetCounter.prototype._doOrder = function (type, color) {
    let self = this
    let itemDef = self._getItemDefInOrderList(type, color)
    // 送花关H5比原生多一个显示收集数量的牌子，这里把掉落优化收集的错误判断里排除掉宝石，实际是计算收集的
    // 排除限时挑战和夺宝的item
    let exclude = (itemDef && (itemDef.id === 6 || itemDef.id === 158 || itemDef.id === 166 || itemDef.id === 242))
    if (itemDef && !exclude && self._orderItemCounted[tostring(itemDef.id)] === false) {
        if (__DEBUG && !GameBoardLogic.instance.replaying) {
            Toast.make("障碍物" + itemDef.id + "被收集，但并未调用DATargetCounter计数，详见掉落优化文档", 30)
            cc.log("请在tryDoOrderAnimal或tryDoOrderByItemDefMapKey之前调用tryDoOrderAnimal")
        }
    }
}
DATargetCounter.prototype.isV2Enable = function () {
    let self = this
    // 202207 当前收集数据两套计数规则共存
    return true
}
